import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import '../../styles/help-center.scss'

const HeroSection = () => {
    return ( 
        <section id="help-center-hero-section">
        <Container>
          <Row className="row justify-content-center">
            <Col className="text-center">
              <h1>Find Professional Treatment Suited To Your Unique Needs</h1>
              <p>Rehab Find helps you quickly sort thr/ough numerous treatment procedures and options that are a perfect fit for your addiction rehabilitation journey.</p>
             </Col>
          </Row>
        </Container>
      </section>
     );
}
 
export default HeroSection;